import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=e0e01ae8&scoped=true&lang=pug&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e01ae8",
  null
  
)

export default component.exports